import { Typography, Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Edge = (props) => {
  return (
    <Box sx={{ mt: '8rem' }}>
      <div>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
            <Typography sx={{ fontWeight: 'bold' }}>What makes us different from other Founder Communities?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              From a conceptual standpoint, we are focussed on forging peer-to-peer relationships. We are looking to
              bring you a tribe of people that can support you on your journey as a founder, while others might be
              focussed on a more top-down approach, with education and mentors.
            </Typography>
            <br></br>

            <Typography>
              From an implementation standpoint, we are unique because are one of the only communities (1) running
              masterminds. It's what we are known for, and what keeps our members so tightknit. Beyond that, (2) the
              events we host are always unique, unorthodox, and modern. They are not your typical networking events
              where everyody is buttoned up. Instead, they are more casual and lively, which leads to our next
              differentiator, (3) a safe and casual environment. We are not a place for people to put on a facade. We
              are a place for people to be themselves, and to be vulnerable. We are a place for people to be real.
              Lastly, (4) our community is exclusive with every member being interviewed and vetted, to ensure that they
              are a good fit.
            </Typography>
            <br></br>
            <Typography>The combination of these elements is what makes The 100 Club a unique community.</Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </Box>
  );
};

export default Edge;
